import React from 'react';

import { Entry } from 'contentful';

import classNames from 'classnames';

import { slugBuilder } from '@/core/contentfulConfig';

import {
  TypeSubFooterFields,
  TypeLink_external,
  TypeLink_externalFields,
  TypeLink_internal,
  TypeLink_internalFields,
} from '@/core/generated-types';

import { Link } from '@/navigation';

type SubFooterProps = {
  fields: TypeSubFooterFields;
  dataTestId?: string;
  isSimpleFooter?: boolean;
};

const SubFooter = ({
  fields,
  dataTestId = 'footer-legal',
  isSimpleFooter = false,
}: SubFooterProps) => {
  const { components: footerLinks, copyright } = fields;

  const date = new Date();

  const currentYear = date.getFullYear();

  return (
    <nav
      className={classNames('py-4 bg-indigo text-white', {
        'px-6 md:px-8': isSimpleFooter,
        'px-8': !isSimpleFooter,
      })}
      data-testid={dataTestId}
    >
      <ul
        className={classNames('w-full font-bold', {
          'flex gap-x-8 gap-y-3 flex-wrap': isSimpleFooter,
          'md:flex md:items-center md:gap-x-8': !isSimpleFooter,
        })}
      >
        {footerLinks?.map(
          (link: Entry<TypeLink_externalFields | TypeLink_internalFields>) => {
            if (link.sys.contentType?.sys.id == 'link_internal') {
              const { linkText = '' } = link?.fields;

              return (
                <li className="hover:underline" key={link.sys?.id}>
                  <Link
                    className="text-sm uppercase"
                    href={slugBuilder(link as TypeLink_internal)}
                  >
                    {linkText}
                  </Link>
                </li>
              );
            } else {
              const { linkUrl = '/', linkText = '' } = (
                link as TypeLink_external
              )?.fields;

              return (
                <li className="hover:underline" key={link.sys?.id}>
                  <Link className="text-sm uppercase" href={linkUrl}>
                    {linkText}
                  </Link>
                </li>
              );
            }
          },
        )}
        <li
          className={classNames({
            '[&>span]:text-sm order-first': isSimpleFooter,
            'text-base ml-auto': !isSimpleFooter,
          })}
        >
          <span>&#169;</span>
          <span>{currentYear}</span>
          {copyright && <span> {copyright}</span>}
        </li>
      </ul>
    </nav>
  );
};

export default React.memo(SubFooter);
